import React, { useRef, useContext, useEffect } from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import ContentWrapper from "styles/contentWrapper"


const StyledSection = styled.section`
  width: 100%;
  height: auto;
  padding: 23rem 0;
  position: relative;
  .image {
    position: absolute;
    top: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.xs}) {
    margin-top: -4rem;
    padding: 13rem 0;
  }
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 0;
    padding-left: 0;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      padding-right: 10%;
      padding-left: 10%;
      max-width: 100%;
    }
  }
`

const StyledInner = styled.div`
  z-index: 1;
  color: white;
  .section-title {
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
    margin-top: 0;
    margin-bottom: 1rem;
    padding: 0 1rem;
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      padding-right: 0;
      padding-left: 0;
    }
    span {
      background-color: #50c4d9;
      padding: .1rem .73rem .35rem .5rem;
      margin-right: 0.5rem;
    }
  }
  .more {
    display: flex;
    justify-content: center;
    margin-top: 5rem;
    .button {
      background-color: #fff;
      border-color: #fff;
      color: #00495d;
      font-size: .7rem;
      font-weight: 700;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: .065rem;
      padding: 1.5rem;
      border-radius: .25rem;
      transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
      &:hover {
        background-color: #e6e6e6;
      }
    }
  }
`

const StyledContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 7.25rem;
  h3 {
    color: white;
    margin-bottom: 1.5rem;
  }
  .description {
    max-width: 200px;
  }

  #lottie2 {
    width: 62%;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
    #lottie2 {
      width: 90%;
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.xs}) {
    flex-direction: column;
    margin-top: 4rem;
    #lottie2 {
      transform: rotate(90deg)!important;
      margin: 11rem 0;
      width: 30rem;
    }
    .description {
      text-align: center;
    }
  }
`

const Workflows = ({ content }) => {
  const { frontmatter } = content[0].node
  const image = getImage(frontmatter.image)
  useEffect(() => {
    const script = document.createElement("script");

    script.src = "https://s3.amazonaws.com/img.riminder.net/animations/workflows-animation.js";
    script.async = true;
    document.body.appendChild(script);
  }, [])
  return (
    <StyledSection id="workflows">
      <GatsbyImage className="image" alt="Worfkflow primary background" image={image} />
      <StyledContentWrapper>
        <StyledInner>
          <h2 className="section-title"><span>{frontmatter.titlePrefix1}</span>{frontmatter.title1}</h2>
          <h2 className="section-title"><span>{frontmatter.titlePrefix2}</span>{frontmatter.title2}</h2>
          <h2 className="section-title"><span>{frontmatter.titlePrefix3}</span>{frontmatter.title3}</h2>
          <StyledContent>
            <div className="description">
              <h3>{frontmatter.leftTitle}</h3>
              <p>{frontmatter.sourcesDescription}</p>
            </div>
            <div id="lottie2"></div>
            <div className="description">
              <h3>{frontmatter.rightTitle}</h3>
              <p>{frontmatter.destinationsDescription}</p>
            </div>
          </StyledContent>
          {frontmatter.buttonText && (
            <div className="more">
              <Link className="button" to={frontmatter.buttonLink}>{frontmatter.buttonText}</Link>
            </div>
          )}
        </StyledInner>
      </StyledContentWrapper>
    </StyledSection>
  )
}


export default Workflows